import { Routes, Route } from "react-router-dom";
import { ApolloProvider } from "@/providers/ApolloProvider";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "./pages/HomePage";
import BusinessPage from "./pages/BusinessPage";
import BranchPage from "./pages/BranchPage";
import RedirectPage from "./pages/RedirectPage";

function App() {
  return (
    <ApolloProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route path="/:businessId" element={<BusinessPage />} />
        <Route path="/:businessId/:branchId" element={<BranchPage />} />
      </Routes>
      <Toaster />
    </ApolloProvider>
  );
}

export default App;
